import { render, staticRenderFns } from "./SelectionSection.vue?vue&type=template&id=324307cc&scoped=true"
import script from "./SelectionSection.vue?vue&type=script&lang=js"
export * from "./SelectionSection.vue?vue&type=script&lang=js"
import style0 from "./SelectionSection.vue?vue&type=style&index=0&id=324307cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324307cc",
  null
  
)

export default component.exports